import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-close-dark',
  templateUrl: './icon-close-dark.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconCloseDarkComponent {}
